import { Injectable } from '@angular/core'
import { MatDialog, MatDialogRef } from '@angular/material/dialog'
import { Observable } from 'rxjs'
import { map, take } from 'rxjs/operators'
import { SupportDialogComponent } from '../support-dialog/support-dialog.component'

@Injectable({ providedIn: 'any' })
export class SupportDialogService {
  constructor(private dialog: MatDialog) {}

  dialogRef!: MatDialogRef<SupportDialogComponent>

  public open(options: any) {
    this.dialogRef = this.dialog.open(SupportDialogComponent, {
      data: {
        title: options.title
      },
      panelClass: options.panelClass || undefined
    })
  }

  public confirmed(): Observable<any> {
    return this.dialogRef.afterClosed().pipe(
      take(1),
      map((res) => {
        return res
      })
    )
  }
}
